import React, {Component} from 'react';
import InputRadio from 'components/atoms/inputs/input-radio';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import SearchPlayer from './search-player';
import {SearchRuleBuilder} from 'services/search-rule-builder';

interface Props {
    csvPlayers: object[];
    onChoosePlayer: (csvPlayer) => void;
}

interface State {
    chosenNameSlug: string;
    searchPlayer: string;
}

class NotMatchedPlayers extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            chosenNameSlug: '',
            searchPlayer: '',
        };
    }
    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        const {csvPlayers: prevCsvPlayers} = prevProps;
        const {csvPlayers} = this.props;

        csvPlayers.length !== prevCsvPlayers.length && this.setState({chosenNameSlug: ''});
    }
    onChoose(csvPlayer): void {
        this.setState({chosenNameSlug: csvPlayer.nameSlug});
        this.props.onChoosePlayer(csvPlayer);
    }
    onSearch(value): void {
        this.setState({searchPlayer: value});
    }
    getCsvPlayers() {
        const {csvPlayers} = this.props;
        const {searchPlayer} = this.state;

        const filteredPlayers = searchPlayer
            ? filterObjectByParams(csvPlayers, SearchRuleBuilder.like('name', searchPlayer), true)
            : csvPlayers;

        return sortArrayOfObjects(filteredPlayers, 'name', 'asc');
    }
    render() {
        return (
            <>
                <SearchPlayer value={this.state.searchPlayer} onSearch={this.onSearch.bind(this)} />
                <div className="match-table-holder">
                    <table className="table">
                        <thead>
                            <tr>
                                <th colSpan={3}>Players from CSV</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getCsvPlayers().map((csvPlayer, index) => {
                                // @ts-ignore
                                const {name, nameSlug, userPoints} = csvPlayer;

                                return (
                                    <tr key={index} onClick={(() => this.onChoose(csvPlayer)).bind(this)}>
                                        <td className="td-chk">
                                            <InputRadio
                                                value={nameSlug}
                                                checked={nameSlug === this.state.chosenNameSlug}
                                                onChange={(() => this.onChoose(csvPlayer)).bind(this)}
                                            />
                                        </td>
                                        <td>{name}</td>
                                        <td>{userPoints}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {!this.getCsvPlayers().length && <div className="match-table-empty">Players were not found.</div>}
                </div>
            </>
        );
    }
}

export default NotMatchedPlayers;
